import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'
import * as ordersConstant from './constants'
import * as ordersAction from './actions'
import { transfersFromCached } from '../../lib/common'

const getOrdersState = state => state.orders;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return response.data;
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    ordersConstant.ORDERS_LIST_API,
    formData
  )

  return handleRequest(request);
}

function exportXlsRequestApi(formData) {
  let url = `${ordersConstant.ORDERS_EXPORT_API}?s=${formData.store_id}&type=${formData.type}&qid=${formData.quanLyId}`
  url += `&kid=${formData.khachHangId}&k=${formData.keyword}&tt=${formData.trangThai}&sd=${formData.startDate}&ed=${formData.endDate}`;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}

function ordersKhachHangApi(formData) {
  const request = axiosApi().post(
    ordersConstant.ORDERS_KHACHHANG_API,
    formData
  )

  return handleRequest(request);
}

function ordersListNvRequestApi(formData) {
  const request = axiosApi().post(
    ordersConstant.ORDERS_LIST_NV_API,
    formData
  )

  return handleRequest(request);
}

function ordersRemoveItemRequestApi(formData) {
  const request = axiosApi().post(
    ordersConstant.ORDERS_REMOVE_ITEM_API,
    formData
  )

  return handleRequest(request);
}

function* ordersListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)
    const data = JSON.parse(results.data)
    // dispatch the action with our widgets!
    yield put(ordersAction.ordersListSuccess(data))

  } catch (error) {
    yield put(ordersAction.ordersListError(error))
  }
}

function* ordersRemoveItemRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(ordersRemoveItemRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(ordersAction.ordersRemoveItemSuccess(results.data))

    if (typeof callback == 'function') {
      callback(results.data);
    }
  } catch (error) {
    yield put(ordersAction.ordersRemoveItemError(error))
  }
}

function* orderListNvFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(ordersListNvRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(ordersAction.ordersListNvSuccess(results.data))

    if (typeof callback == 'function') {
      callback(results.data);
    }
  } catch (error) {
    yield put(ordersAction.ordersListNvError(error))
  }
}

function* ordersKhachHangRequestFlow({payload}) {
  try {
    // grab the client from our action
    const results = yield call(ordersKhachHangApi, payload)
    if (results && results.records) {
      // dispatch the action with our widgets!
      yield put(ordersAction.ordersKhachHangSuccess(transfersFromCached(results.records)))
    }
  } catch (error) {
    yield put(ordersAction.ordersKhachHangError(error))
  }
}
function ordershDaiLyApi(formData) {
  const request = axiosApi().post(
    ordersConstant.ORDERS_DAILY_API,
    formData
  )

  return handleRequest(request);
}
function* ordersDaiLyRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(ordershDaiLyApi, formData)
    // dispatch the action with our widgets!
    yield put(ordersAction.ordersDaiLySuccess(results.data))
    if (typeof callback == 'function') {
      callback(results.data);
    }
  } catch (error) {
    yield put(ordersAction.ordersDaiLyError(error))
  }
}
function* ordersExportXlsRequestFlow({ payload, onSuccess }) {
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, payload)
    if (!results || (results.code && results.code != 200)) {
      return yield put(ordersAction.ordersExportXlsError("Lỗi trong quá trình lấy dữ liệu"))
    }
    if (results.code && results.code != 200) {
      return yield put(ordersAction.ordersExportXlsError(results.message))
    }
    // dispatch the action with our widgets!
    yield put(ordersAction.ordersExportXlsSuccess())
    // callback on success
    if (typeof onSuccess === 'function') {
      yield call(onSuccess, results)
    }
  } catch (error) {
    yield put(ordersAction.ordersExportXlsError(error))
  }
}

function* approveOrders () {
  try {
    const orders = yield select(getOrdersState);
    const {
      formData,
      callback,
    } = orders
    const request = axiosApi().post(
      ordersConstant.ORDERS_APPROVE_LIST_API,
      formData
    )
    const {code, message, data} = yield call(handleRequest, request);
    console.log(data)
    if (code != 200) {
      yield put(ordersAction.setApproveError(message))
    } else {
      if (data.failed && data.failed.length > 0) {
        const errorMsg = data.failed.map((err) => { return err.message })
        yield put(ordersAction.setApproveError(errorMsg))
      } else {
        yield put(ordersAction.setApproveMessage(`Hoàn thanh danh sách đơn thành công`))
      }
      if (data.passed && data.passed.length > 0) {
        yield call(callback)
      }
    }
  } catch (error) {
    yield put(ordersAction.setApproveError(error.toString()))
  }
}

function* ordersWatcher() {
  yield takeLatest(ordersConstant.ORDERS_LIST_NV_REQUESTING, orderListNvFlow)

  yield [
    takeEvery(ordersConstant.ORDERS_LIST_REQUESTING, ordersListRequestFlow),
    takeEvery(ordersConstant.ORDERS_REMOVE_ITEM_REQUESTING, ordersRemoveItemRequestFlow),
    takeEvery(ordersConstant.ORDERS_KHACHHANG_REQUESTING, ordersKhachHangRequestFlow),
    takeEvery(ordersConstant.ORDERS_DAILY_REQUESTING, ordersDaiLyRequestFlow),
    takeEvery(ordersConstant.ORDERS_EXPORT_XLS_REQUESTING, ordersExportXlsRequestFlow),
    takeEvery(ordersConstant.ORDERS_APPROVE_LIST_REQUESTING, approveOrders),
  ]
}

export default ordersWatcher



// WEBPACK FOOTER //
// ./src/views/Orders/sagas.js